module.exports = __webpack_public_path__ + "static/media/invision.de3ba0f2.svg";